<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.mixed_waste_bins')"/>
        <div class="col-sm-12 my-2">
            <Transition name="fade">
                <keep-alive>
                    <mixed-waste-bins-search
                        :user="user"
                        @search="fetchMixedWasteBins"
                        @clear="clearResults"
                    />
                </keep-alive>
            </Transition>
            <Transition name="fade">
                <div class="col-sm-12">
                    <div
                        class="button-container col-sm-12 trip-buttons"
                    >
                    </div>
                    <mixed-waste-bins-list
                        :mixed-waste-bins="results"
                        @row-clicked="editMixedWasteBin"
                    />
                </div>
            </Transition>
        </div>

        <mixed-waste-bins-wizard
            v-if="mixedWasteBin != null"
            :mixed-waste-bin="mixedWasteBin"
            @close="mixedWasteBin=null"
            @close-and-update="closeAndUpdate"
        />

        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import MixedWasteBinsSearch from "@/components/mixedwastebins/MixedWasteBinsSearch";
import MixedWasteBinsList from "@/components/mixedwastebins/MixedWasteBinsList";
import {inject} from "vue";
import MixedWasteBinsWizard from "@/components/mixedwastebins/MixedWasteBinsWizard";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'MixedWasteBins',
    components: {Navbar, MixedWasteBinsWizard, MixedWasteBinsList, MixedWasteBinsSearch},
    mixins: [restApi, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            mixedWasteBin: null,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false
        }
    },

    methods: {
        fetchMixedWasteBins: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.mixedWasteBinUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            if (response && response.data) {
                this.results = response.data
            }
            this.loading = false
        },
        editMixedWasteBin: function (mixedWasteBin) {
            this.mixedWasteBin = this.results.find(item => item.id === mixedWasteBin.id)
        },
        closeAndUpdate: function () {
            this.mixedWasteBin = null
            this.showAlert(this.$t('common.alert_update_success'), 'success')
            this.fetchMixedWasteBins(this.lastSearchedParams)
        },
        clearResults: function() {
            this.results = []
            this.lastSearchedParams = null
        }
    }
}
</script>
